import { useCallback, useState, useEffect } from 'react';

import { useIsEditorToolbarDockedAtTop } from '@confluence/content-types-header/entry-points/useIsEditorToolbarDockedAtTop';
import {
	getBannerType,
	persistBannerDismissalNewPinning,
	isBannerDismissedInLocalStorage,
} from '@confluence/editor-controls-banner-dismissal';

export const useIsControlsBannerDismissed = (isLivePage: boolean) => {
	const isEditorToolbarDockedAtTop = useIsEditorToolbarDockedAtTop({
		defaultDockedAtTop: !isLivePage,
	});

	const bannerType = getBannerType(isEditorToolbarDockedAtTop);

	const [isControlsBannerDismissed, setIsControlsBannerDismissed] = useState(() =>
		isBannerDismissedInLocalStorage(bannerType),
	);

	useEffect(() => {
		setIsControlsBannerDismissed(isBannerDismissedInLocalStorage(bannerType));
	}, [bannerType]);

	const onDismiss = useCallback(() => {
		setIsControlsBannerDismissed(true);
		persistBannerDismissalNewPinning(bannerType);
	}, [bannerType]);

	return { isControlsBannerDismissed, onDismiss, bannerType };
};
